import { Divider, Image, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Text, VStack } from "@chakra-ui/react";
import { colors } from "../../styles";

interface TermsOfUseModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export default function TermsOfUseModal(props: TermsOfUseModalProps) {
    return (
        <Modal size="2xl" motionPreset="slideInBottom" scrollBehavior="inside" isOpen={props.isOpen} onClose={props.onClose}>
            <ModalOverlay />
            <ModalContent maxH="90vh">
                <ModalHeader>
                    <Text fontSize={20} fontWeight={700} color={colors.black}>이용약관</Text>
                    <ModalCloseButton />
                </ModalHeader>
                <ModalBody paddingBottom={5}>
                    <Text fontSize={16} fontWeight={700} color={colors.black}>
                        팜챗(PharmChat) 이용약관
                    </Text>

                    <Divider marginY={5} />

                    {/* 제 1장 총칙 */}

                    <Text fontSize={16} fontWeight={700} color={colors.black} flexWrap={"wrap"}>
                        제 1장 총칙
                    </Text>

                    <VStack
                        justifyContent={"flex-start"}
                        alignItems={"flex-start"}
                        width={"100%"}
                        padding={5}
                        spacing={5}
                    >

                        {/* 레이블 */}

                        <Text fontSize={14} fontWeight={700} color={colors.black}>
                            제 1조 [목적]
                        </Text>

                        {/* 내용 */}

                        <Text fontSize={14} fontWeight={400} color={colors.black} flexWrap={"wrap"}>
                            본 약관은 주식회사 더리얼(이하 “회사”)이 운영하는<br />
                            의약품 정보 웹 플랫폼 “팜챗(PharmChat)”(이하 “서비스”)을 이용함에 있어<br />
                            회사와 이용자 사이의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.
                        </Text>

                        {/* 레이블 */}

                        <Text fontSize={14} fontWeight={700} color={colors.black}>
                            제 2조 [용어의 정의]
                        </Text>

                        {/* 내용 */}

                        <Text fontSize={14} fontWeight={400} color={colors.black} flexWrap={"wrap"}>
                            ① “서비스”란 회사가 웹사이트를 통해 제공하는 의약품 정보 검색, 데이터 분류, 정보 통합 서비스를 의미합니다.<br />
                           ② “이용자”란 본 약관에 동의하고 서비스를 이용하는 회원 및 비회원을 말합니다.<br />
                           ③ “공급처”란 의약품 등을 판매하는 제약회사, 건강기능식품회사, 의약품 도매상 등의 사업자를 의미합니다.<br />
                        </Text>
                    </VStack>

                    {/* 제 2장 서비스의 제공 및 이용 */}

                    <Text fontSize={16} fontWeight={700} color={colors.black} flexWrap={"wrap"}>
                        제 2장 서비스의 제공 및 이용
                    </Text>

                    <VStack
                        justifyContent={"flex-start"}
                        alignItems={"flex-start"}
                        width={"100%"}
                        padding={5}
                        spacing={5}
                    >

                        {/* 레이블 */}

                        <Text fontSize={14} fontWeight={700} color={colors.black}>
                            제 3조 [서비스의 내용 및 변경]
                        </Text>

                        {/* 내용 */}

                        <Text fontSize={14} fontWeight={400} color={colors.black} flexWrap={"wrap"}>
                            ① 회사는 이용자에게 다음 각 호의 서비스를 제공합니다.
                        </Text>
                        <Text fontSize={14} fontWeight={400} color={colors.black} flexWrap={"wrap"} marginLeft={5}>
                            1. 의약품 및 관련 제품의 통합 검색 및 정보 조회 서비스<br />
                            2. 제품 속성(제형, 규격, 성분 등)에 따른 데이터 분류 및 검색 편의 서비스<br />
                            3. 공급처별 제품 가격 정보 제공 (회원 등급별 제한 가능)<br />
                            4. 서비스 내 정보성 광고 및 마케팅 콘텐츠 게재<br />
                        </Text>

                        <Text fontSize={14} fontWeight={400} color={colors.black} flexWrap={"wrap"}>
                            ② 회사는 기술적 사양의 변경이나 운영 정책에 따라 웹사이트 내 서비스 내용 및 기능을
                            상시 수정하거나 중단할 수 있습니다.
                        </Text>

                        {/* 레이블 */}

                        <Text fontSize={14} fontWeight={700} color={colors.black}>
                            제 4조 [회원 등급 및 권한 차별화]
                        </Text>

                        {/* 내용 */}

                        <Text fontSize={14} fontWeight={400} color={colors.black} flexWrap={"wrap"}>
                            ① 회사는 회원의 자격(약사, 약대생, 개국약사 등) 확인 결과에 따라
                            서비스 기능의 접근 권한을 차등 부여할 수 있습니다.<br />
                            ② 회사는 향후 운영 방침에 따라 회원 등급별 기능을 신설, 제한 또는 차별화할 수 있으며,<br />
                            이에 관한 사항은 웹사이트 내 공지사항을 통해 게시합니다.
                        </Text>

                        {/* 레이블 */}

                        <Text fontSize={14} fontWeight={700} color={colors.black}>
                            제 5조 [광고의 게재]
                        </Text>

                        {/* 내용 */}

                        <Text fontSize={14} fontWeight={400} color={colors.black} flexWrap={"wrap"}>
                            ① 회사는 서비스의 운영과 관련하여 웹사이트 화면(피드 영역 등 포함) 내에 광고를 게재할 수 있으며,
                            이용자는 서비스 이용 시 노출되는 광고 게재에 대하여 동의합니다.<br />
                            ② 광고주와 이용자 간의 거래로 인해 발생하는 결과에 대해 회사는 고의 또는 중과실이 없는 한 책임을 지지 않습니다.
                        </Text>
                    </VStack>

                    {/* 제 3장 데이터 보호 및 면책 */}

                    <Text fontSize={16} fontWeight={700} color={colors.black} flexWrap={"wrap"}>
                        제 3장 데이터 보호 및 면책
                    </Text>

                    <VStack
                        justifyContent={"flex-start"}
                        alignItems={"flex-start"}
                        width={"100%"}
                        padding={5}
                        spacing={5}
                    >

                        {/* 레이블 */}

                        <Text fontSize={14} fontWeight={700} color={colors.black}>
                            제 6조 [정보의 정확성 및 면책]
                        </Text>

                        {/* 내용 */}

                        <Text fontSize={14} fontWeight={400} color={colors.black} flexWrap={"wrap"}>
                            ① 서비스에서 제공되는 가격, 규격, 속성 등 모든 정보는 공급처 자료를 기반으로 한 참고용 데이터이며,
                            회사는 정보의 실시간성이나 완전성을 보장하지 않습니다.<br />
                            ② 이용자는 본 정보를 전문가로서의 식견에 따라 활용해야 하며, 정보의 불일치로 인해 발생하는 손해에 대해 회사는 책임을 지지 않습니다.
                        </Text>

                        {/* 레이블 */}

                        <Text fontSize={14} fontWeight={700} color={colors.black}>
                            제 7조 [지식재산권 및 데이터 보호]
                        </Text>

                        {/* 내용 */}

                        <Text fontSize={14} fontWeight={400} color={colors.black} flexWrap={"wrap"}>
                            ① 서비스 내의 데이터베이스 구성, 분류 체계, 검색 로직 및 서비스와 관련된 모든 콘텐츠의 지식재산권은 회사에 귀속됩니다.<br />
                            ② 이용자는 회사의 서면 승인 없이 자동화된 수단(로봇, 크롤러 등)을 사용하여
                            데이터를 무단 수집, 복제 또는 가공하는 행위를 하여서는 안 됩니다.
                        </Text>
                    </VStack>

                    {/* 제 4장 기타 */}

                    <Text fontSize={16} fontWeight={700} color={colors.black} flexWrap={"wrap"}>
                        제 4장 기타
                    </Text>

                    <VStack
                        justifyContent={"flex-start"}
                        alignItems={"flex-start"}
                        width={"100%"}
                        padding={5}
                        spacing={5}
                    >

                        {/* 레이블 */}

                        <Text fontSize={14} fontWeight={700} color={colors.black}>
                            제 8조 [준거법 및 재판관할]
                        </Text>

                        {/* 내용 */}

                        <Text fontSize={14} fontWeight={400} color={colors.black} flexWrap={"wrap"}>
                            ① 회사와 이용자 사이에 발생한 분쟁에 대하여는 대한민국의 법률을 적용합니다.<br />
                            ② 본 서비스와 관련된 소송의 관할법원은 회사의 본점 소재지 관할 법원으로 합니다.
                        </Text>
                    </VStack>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}